<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          Engineering Excellence
        </h1>
        <p class="subheading font-weight-regular">
          Delivering training, consultation, and software design for almost a decade.
        </p>
      </v-flex>

      <v-flex
        mb-5
        xs12
      >
        <h2 class="headline font-weight-bold mb-3">What's next?</h2>
        <h3>Take a look at some of my latest samples from my <router-link to="/demos">demos</router-link></h3>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    
  }),
};
</script>
